import { planCheckoutResponseSchema, planPortalResponseSchema } from "../../schemas/finance";
import { fetchApi } from "../client/internal";

// The club's OWN platform plan (Club / Club Pro / Verband), billed on the platform
// Stripe account — distinct from member membership-fee subscriptions in `billing`.
export const plan = {
	createCheckout: (clubId: string, tier: string) =>
		fetchApi(`/${clubId}/plan/checkouts`, planCheckoutResponseSchema, {
			method: "POST",
			body: JSON.stringify({ tier }),
		}),
	openPortal: (clubId: string) =>
		fetchApi(`/${clubId}/plan/portal`, planPortalResponseSchema, {
			method: "POST",
		}),
};
